import { Component, OnDestroy, OnInit, Inject } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LoggerService } from '../../services/logger.service';
import { SpinnerState, SpinnerService } from './spinner.service';
import { fadeInAnimation } from '../../animations/fade-in.animation';


export class SpinnerComponent implements OnDestroy, OnInit {
    visible = false;
    count = 0;

    private spinnerStateChanged: Subscription;

    constructor(
         private loggerService: LoggerService,
        private spinnerService: SpinnerService
    ) { }

    ngOnInit() {
        this.loggerService.log('... initializing spinner component from core module.');
        this.spinnerStateChanged = this.spinnerService.spinnerState
            .subscribe((state: SpinnerState) => {
              if (state.show) {
                this.count++;
              } else {
                this.count--;
              }
              if (this.count > 0) {
                this.visible = true;
              } else {
                this.visible = false;
              }
              // this.visible = state.show;
        });
    }

    ngOnDestroy() {
        this.spinnerStateChanged.unsubscribe();
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[leaf-spinner]',
  template:  `
    <a class="btn btn-primary minimalize-styl-item" *ngIf="visible" [@fadeInAnimation]><i class="fa fa-circle-o-notch fa-spin"></i></a>
  `,
  animations: [fadeInAnimation]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LoggerService, decorators: [{ type: Inject, args: ['LoggerService', ] }, ]},
{type: SpinnerService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
